import { number, string, bool, arrayOf, shape } from 'prop-types';

const identificationTypePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
};

const customerPropTypes = {
  id: number.isRequired,
  firstName: string,
  lastName: string,
  fullName: string,
  idDocumentNumber: string,
  identificationTypeId: number,
  identificationType: shape(identificationTypePropTypes),
};

const registeredBusPropTypes = {
  id: number.isRequired,
  companyBusId: string,
  licensePlate: string,
};

const tollLiquidationDetailPropTypes = {
  id: number.isRequired,
  tollLiquidationId: number.isRequired,
  tollId: number.isRequired,
  tollName: string.isRequired,

  tollAmount: number,
  tollAmountApplied: bool,

  detractionAmount: number,
  detractionApplied: bool,

  totalAmount: number,
};

const differenceReasonPropTypes = {
  id: number.isRequired,
  name: string,
  description: string,
};

const tollLiquidationPropTypes = {
  id: number.isRequired,

  itineraryId: number,
  routeId: number,
  routeName: string,
  circuitId: number,
  circuitName: string,

  totalAmount: number,
  tollLiquidateAmount: number,

  registeredBusId: number,
  registeredBus: shape(registeredBusPropTypes),

  payeeCustomerId: number,
  payeeCustomer: shape(customerPropTypes),

  differenceAmount: number,
  differenceAmountReasonId: number,
  differenceReason: shape(differenceReasonPropTypes),

  observation: string,

  tollLiquidationDetailList: arrayOf(shape(tollLiquidationDetailPropTypes)),
};

const tollLiquidationDefaultProps = {
  tollLiquidationDetailList: [],
};

export {
  tollLiquidationPropTypes,
  tollLiquidationDefaultProps,
  tollLiquidationDetailPropTypes,
};
